/**
 * GA4 event tracking helpers for MyPizzeria leaderboard.
 *
 * Wraps window.gtag() with null-safety — no-ops when gtag is undefined
 * (dev/test environments without the GA snippet).
 */

function sendToGtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args)
  }
}

export function trackFilterChange(filterType, filterValue) {
  sendToGtag("event", "leaderboard_filter", {
    filter_type: filterType,
    filter_value: filterValue,
  })
}

export function trackCtaClick(ctaType, ctaLocation) {
  sendToGtag("event", "leaderboard_cta_click", {
    cta_type: ctaType,
    cta_location: ctaLocation,
  })
}
